import { render } from "./TournamentActivityCreatePage.vue?vue&type=template&id=998a59f8"
import script from "./TournamentActivityCreatePage.vue?vue&type=script&lang=js"
export * from "./TournamentActivityCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__